import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageStrideAngles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_92",
		"data-name": "Group 92",
		transform: "translate(-141.778 -531.182)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_26",
				"data-name": "Rectangle 26",
				width: 24,
				height: 24,
				transform: "translate(142.278 531.682)",
				fill: "none",
				stroke: "#040505",
				strokeMiterlimit: 10,
				strokeWidth: 1,
				opacity: 0
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_222",
				"data-name": "Path 222",
				d: "M157.187,560.467",
				transform: "translate(-9.322 -17.997)",
				fill: "none",
				stroke: "#040505",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 4
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_223",
				"data-name": "Path 223",
				d: "M166.652,554.15c-.174-.218-.377-.467-.594-.731a16.284,16.284,0,0,1-2.207-3.1c-.368-1.091-1.009-4.23-1.267-5.528a.9.9,0,0,0-.252-.461c.112-.136.234-.277.379-.423.924-.931,3.252-3.224,3.275-3.247a.749.749,0,1,0-1.052-1.068c-.023.023-2.358,2.322-3.287,3.259a6.7,6.7,0,0,0-1.309,1.807l-.059.041a2.388,2.388,0,0,1-1.148-.881,3.071,3.071,0,0,1-.347-1.206c0-.033-.015-.064-.02-.1.224-.157.5-.364.861-.634a21.7,21.7,0,0,0,3.163-3.579.749.749,0,0,0-1.217-.875,19.922,19.922,0,0,1-2.844,3.254c-.47.352-.747.549-.906.659a1.5,1.5,0,0,0-.962-.049,7.419,7.419,0,0,0-1.309.521,13.587,13.587,0,0,0-2.2,1.37,4.467,4.467,0,0,0-1.58.57.749.749,0,0,0-.421.562,4.663,4.663,0,0,0,1.3,3.535c1.353,1.611,6.222,6.345,6.453,6.568.109.1,2.7,2.381,4.993,2.608.155.015.307.023.453.023a2.461,2.461,0,0,0,2.283-1.1A1.617,1.617,0,0,0,166.652,554.15ZM158.1,541.419a.758.758,0,0,0-.157-.017A.743.743,0,0,1,158.1,541.419Zm-.159-.017h0Zm7.576,13.835c-.089.163-.5.38-1.272.3-1.5-.149-3.5-1.665-4.121-2.214-.05-.049-5.021-4.882-6.325-6.435a3.88,3.88,0,0,1-.954-1.973c.236-.1.446-.187.558-.223l.112.011a.747.747,0,0,0,.57-.182,11.2,11.2,0,0,1,2.143-1.367,5.238,5.238,0,0,1,1.059-.413c.009.006.009.011.009.013a4.45,4.45,0,0,0,.541,1.813,4.1,4.1,0,0,0,2.4,1.7.753.753,0,0,0,.648-.141c.119-.094.254-.192.383-.28.341,1.676.836,3.982,1.164,4.956a14.853,14.853,0,0,0,2.468,3.568c.212.259.41.5.58.714C165.549,555.171,165.527,555.212,165.513,555.237Z",
				transform: "translate(-5.657 -3.4)",
				fill: "current"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgAverageStrideAngles);
export { ForwardRef as ReactComponent };
